<h1 mat-dialog-title>Edit Interactive Pre Filters</h1>
<div mat-dialog-content class="container-admin">
  <mat-tab-group [(selectedIndex)]="selectedIndex">
    <mat-tab label="Pre-Filter Keys">
      <button class="piButton" mat-raised-button (click)="createNewKey()">Create New Key</button>
      <div style="margin-top: 30px">
        <table width="100%">
        <tr>
          <th>Name</th>
          <th>Filter Type</th>
          <th>Dax Field(s)</th>
          <th>Actions</th>
        </tr>
        <tr *ngFor="let filter of preFilterData">
          <td>{{filter.name}}</td>
          <td>
            <ng-container *ngIf="filter.keyType === 0">Flat Selection</ng-container>
            <ng-container *ngIf="filter.keyType === 1">Hierarchy Selection</ng-container>
            <ng-container *ngIf="filter.keyType === 2">Keyword Entry</ng-container>
          </td>
          <td>{{filter.daxName}}</td>
          <td>
            <button class="piButton" mat-raised-button (click)="editFilterKey(filter.preFilterKeyId)">Edit</button>
            <button class="piButton" mat-raised-button (click)="deleteFilterKey(filter.preFilterKeyId)">Delete</button>
          </td>
        </tr>
      </table>
      </div>
    </mat-tab>
    <mat-tab *ngIf="selectedPreFilter" label="Key Details" class="mat-tab-override">
      <ng-container *ngIf="!selectedPreFilter">
        Edit or Create New Key In Previous Tab
      </ng-container>

      <ng-container *ngIf="selectedPreFilter">
        <div class="row">
          <div class="col-md-3">
            <b>Name: </b><br /><input [(ngModel)]="preFilterName" />
          </div>
          <div class="col-md-3">
            <b>Filter Type: </b><br />
            <ng-container *ngIf="editMode === 'New'">
              <mat-select [(ngModel)]="preFilterType">
                <mat-option [value]="0">Flat Selection</mat-option>
                <mat-option [value]="1">Hierarchy Selection</mat-option>
                <mat-option [value]="2">Keyword Selection</mat-option>
              </mat-select>
            </ng-container>
            <ng-container *ngIf="editMode === 'Edit'">
              <ng-container [ngSwitch]="preFilterType">
                <ng-container *ngSwitchCase="0">
                  Flat Selection
                </ng-container>
                <ng-container *ngSwitchCase="1">
                  Hierarchy Selection
                </ng-container>
                <ng-container *ngSwitchCase="2">
                  Keyword Selection
                </ng-container>
              </ng-container>
            </ng-container>
          </div>
          <div class="col-md-3">
            <ng-container>
              <b>Dax Field: </b><br /><input [(ngModel)]="preFilterDax" />
            </ng-container>
          </div>
          <div class="col-md-3">
            <ng-container *ngIf="editMode === 'New'">
              <button class="piButton" mat-raised-button (click)="createNewFilterKey()">Save New</button>
            </ng-container>
            <ng-container *ngIf="editMode === 'Edit'">
              <button class="piButton" mat-raised-button (click)="saveFilterKey()">Update</button>
            </ng-container>
            <button class="piButton" mat-raised-button (click)="cancelChanges()">Cancel</button>
          </div>
        </div>
      </ng-container>
      <br />
      <!-- Flat Selection -->
      <ng-container *ngIf="preFilterType === 0">
        <div class="row">
          <div class="col-md-12">
            <button class="piButton" mat-raised-button *ngIf="!!this.selectedPreFilter && this.editMode === 'Edit'" (click)="refreshFilterKeyValues()">Refresh Values</button>
            <br />
            <textarea [readOnly]="true" rows="12" style="width: 95%" [(ngModel)]="allKeys"></textarea><br />
            <br />
            <b>Last Refreshed (UTC): </b>{{selectedPreFilter.lastUpdate | date : 'medium' }}
          </div>
        </div>
        <!-- <div>
          <b>Key Values For:</b> {{this.selectedPreFilter?.name}}<br />
          <small>Each line is a selectable entry.</small>
          <textarea [readOnly]="true" rows="15" cols="50" [(ngModel)]="allKeys"></textarea><br />
          <ng-container *ngIf="selectedPreFilter">
            <b>Last Refreshed (UTC): </b>{{selectedPreFilter.lastUpdate | date : 'medium' }}
          </ng-container>
          <br />
          <button class="piButton" mat-raised-button *ngIf="!!this.selectedPreFilter && this.editMode === 'Edit'" (click)="refreshFilterKeyValues()">Refresh Values</button>
        </div> -->
      </ng-container>

      <!-- Hierarchy Selection -->
      <ng-container *ngIf="preFilterType === 1">
        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-sm-4">
                <b>Dax Field: </b><br /><input [(ngModel)]="hierarchyDaxField" />
              </div>
              <div class="col-sm-4">
                <b>Level: </b><br /><input type="number" min="1" max="10" [(ngModel)]="hierarchyLevel" />
              </div>
              <div class="col-sm-4">
                <button class="piButton" mat-raised-button (click)="addHierarchyLevel()" >Add Hierarchy</button>
              </div>
            </div>
            <br />
            <div class="row" style="max-height: 260px; overflow-y: scroll">
              <div class="col-md-12">
                <table style="width: 100%">
                  <tr>
                    <th>Dax Field</th>
                    <th>Level</th>
                    <th>Remove</th>
                  </tr>
                  <tr *ngFor="let daxField of hierarchyDaxKeys(); let i = index;">
                    <td>{{daxField.daxName}}</td>
                    <td>{{daxField.hierarchyLevel}}</td>
                    <td><button class="piButton" mat-raised-button (click)="removeHierarchy(i)" >Remove</button></td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <button class="piButton" mat-raised-button *ngIf="!!this.selectedPreFilter && this.editMode === 'Edit'" (click)="refreshFilterKeyValues()">Refresh Values</button>
            <app-pre-filter-hierarchy-editor
              [preFilterKey]="selectedPreFilter"
              [allowSelect]="false"
              title="Show Hierarch Values"
              [maxHeight]="200"
            >
            </app-pre-filter-hierarchy-editor>
            <b>Last Refreshed (UTC): </b>{{selectedPreFilter.lastUpdate | date : 'medium' }}
          </div>
        </div>
      </ng-container>

      <!-- Keyword Entry -->
      <ng-container *ngIf="preFilterType === 2">
        <b>-- No Options --</b>
      </ng-container>
    </mat-tab>
  </mat-tab-group>
</div>
<div mat-dialog-actions>
  <button mat-raised-button (click)="onCloseClick()">Close</button>
</div>
